import { Notifications } from "./notifications_tab/Notifications"
import { Topics } from "./topics_tab/Topics"
import { HashTabSection } from "../../components/Helpers"

export function NotificationsContainer() {
  return (
    <HashTabSection
      defaultTab="notifications"
      tabItems={[
        { id: "notifications", label: "Notifications" },
        { id: "topics", label: "Topics" },
      ]}
      tabContent={{
        notifications: <Notifications />,
        topics: <Topics />,
      }}
    />
  )
}
